import React from 'react';
import AddNoteDialogView from './components/AddNoteDialogView';
import { AddNoteDialogControllerProps, useAddNoteDialogController } from './hooks/useAddNoteDialogController';

const AddNoteDialog: React.FC<AddNoteDialogControllerProps> = (props) => {
    const ctrl = useAddNoteDialogController(props);
    return <AddNoteDialogView {...ctrl} />;
};

export default AddNoteDialog;
